import React, { useState, useEffect, useRef } from 'react';
import { Card } from 'primereact/card';
import { MultiSelect } from 'primereact/multiselect';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
// import './dashboard.css'
import { useSelector } from 'react-redux'
import { Calendar } from 'primereact/calendar';
import { Avatar } from 'primereact/avatar';
import AppModal from '../../shared/AppModal';
import AppsTable from '../../components/apps/appsTable';
import FlexComponent from '../../components/FlexComponent';

export default function UserActivityDashboardKPIs({ data, userId }) {

    // console.log("data_____", data);

    const toast = useRef(null);
    const [tableVisible, setTableVisible] = useState(false)

    // const [popupTableData, setpopupTableData] = useState({
    //     app_count_list: [],
    //     credit_pulled_app_list: [],
    //     closed_leads_list: [],
    //     pending_closings_id_list: [],
    //     projected_closings_id_list: [],
    //     open_leads_list: [],
    //     docs_in_list: [],
    //     preapps_list: [],
    //     shoppers_list: [],
    //     total_replies_id_list: [],
    //     repeat_leads : [],
    //     speed_to_leads : []
    // })

    const [tableData, setTableData] = useState([])
    const [isLineChart, setIsLineChart] = useState(false)

    const [popupHeader, setPopupHeader] = useState("")

    const headerDialogue = () => {
        return (
            <FlexComponent justifyContent="start" gap="1rem" style={{ padding: ".5rem" }} >
                <div style={{ cursor: "pointer", borderBottom: !isLineChart ? '5px solid white' : 'none', height: "35px" }} onClick={() => {
                    setIsLineChart(false)
                }} >{popupHeader}</div>
                {/* <div style={{cursor: "pointer", borderBottom: isLineChart ? '5px solid white' : 'none', height: "35px"}} onClick={()=> {
                    setIsLineChart(true)
                }} >Line Chart</div> */}
            </FlexComponent>
        );
    }


    return (
        <div className='activityDashboardKpis' style={{ width: "100%" }} >
            <Toast ref={toast} />

            <div className='dashboard-card-container' style={{ justifyContent: "center" }} >
                <div className="dash-card-container flex justify-content-center">
                    <Card title="Apps" style={{ pointerEvents: data.apps_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Apps")
                        setTableData(data.apps_list)
                    }} subTitle={<div >{data.apps_count}</div>} >
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Docs In" style={{ pointerEvents: data.docs_in_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Docs In")
                        setTableData(data.docs_in_list)
                    }} subTitle={<div>{data.docs_in_count}</div>} >
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Credit" style={{ pointerEvents: data.credit_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Credit Pulled")
                        setTableData(data.credit_list)
                    }} subTitle={<div>{data.credit_count}</div>} >
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="PreApps" style={{ pointerEvents: data.preapps_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total PreApps")
                        setTableData(data.preapps_list)
                    }} subTitle={<div>{data.preapps_count}</div>} >
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Open" style={{ pointerEvents: data.opens_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Open Deals")
                        setTableData(data.opens_list)
                    }} subTitle={<div>{data.opens_count}</div>} >
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Closed" style={{ pointerEvents: data.closed_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Closed Deals")
                        setTableData(data.closed_list)
                    }} subTitle={<div>{data.closed_count}</div>} >
                    </Card>
                </div>


                <div className="dash-card-container flex justify-content-center">
                    <Card title="Projected" style={{ pointerEvents: data.projected_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Projected")
                        setTableData(data.projected_list)
                    }} subTitle={<div>{data.projected_count}</div>} >
                    </Card>
                </div>

                <div className="dash-card-container flex justify-content-center">
                    <Card title="Pending" style={{ pointerEvents: data.pending_count ? "all" : "none", cursor: "pointer" }} onClick={() => {
                        setTableVisible(true)
                        setPopupHeader("Total Pending")
                        setTableData(data.pending_list)
                    }} subTitle={<div>{data.pending_count}</div>} >
                    </Card>
                </div>

                <AppModal header={headerDialogue} visible={tableVisible} panelStyle={{ width: '90vw', minHeight: '70vh' }} onHide={() => { if (!tableVisible) return; setTableVisible(false); }}>
                    <div>
                        {!isLineChart && tableData?.length > 0 && <AppsTable popupHeader={popupHeader} userId={userId} countsIds={tableData} />}
                        {/* {isLineChart && <LineChartSample />} */}
                        {/* <ArchivedAppsTable */}
                    </div>
                </AppModal>

            </div>
        </div>
    )
}